import { render, staticRenderFns } from "./PushNotificationManager.vue?vue&type=template&id=16ca66bc&scoped=true"
import script from "./PushNotificationManager.vue?vue&type=script&lang=js"
export * from "./PushNotificationManager.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationManager.vue?vue&type=style&index=0&id=16ca66bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca66bc",
  null
  
)

export default component.exports